/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanCandidateRejectionReasonEnum =
  (typeof RoutePlanCandidateRejectionReasonEnum)[keyof typeof RoutePlanCandidateRejectionReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanCandidateRejectionReasonEnum = {
  AlreadyUsedInRun: 0,
  MissingCapability: 1,
  CommuteTooLong: 2,
  NotAvailable: 3,
  DrivingPolicyBlocked: 4,
  RunnerCustomerContact: 5,
  CannotReachExistingAssignment: 6,
} as const;
